export default __webpack_public_path__ + "static/media/icon-leaf-green.dbd38b7d.svg";